export type GameState = 'BOOT' | 'LOADING' | 'MENU' | 'STARTING' | 'PLAYING' | 'DYING' | 'DEAD' | 'PAUSED'
export type GameEvent = 'booted' | 'loaded' | 'play' | 'started' | 'die' | 'settled' | 'retry' | 'pause' | 'resume' | 'menu'

const TRANSITIONS: Readonly<Record<GameState, Partial<Record<GameEvent, GameState>>>> = {
  BOOT: { booted: 'LOADING' },
  LOADING: { loaded: 'MENU' },
  MENU: { play: 'STARTING' },
  STARTING: { started: 'PLAYING', menu: 'MENU' },
  PLAYING: { die: 'DYING', pause: 'PAUSED', menu: 'MENU' },
  DYING: { settled: 'DEAD' },
  DEAD: { retry: 'STARTING', menu: 'MENU' },
  PAUSED: { resume: 'PLAYING', menu: 'MENU' },
}

export class GameStateMachine {
  private currentState: GameState
  private readonly listeners = new Set<(state: GameState) => void>()

  public constructor(initialState: GameState = 'BOOT') {
    this.currentState = initialState
  }

  public get state(): GameState {
    return this.currentState
  }

  public send(event: GameEvent): void {
    const nextState = TRANSITIONS[this.currentState][event]
    if (nextState === undefined) throw new Error(`Invalid transition: ${this.currentState} + ${event}`)
    this.currentState = nextState
    for (const listener of this.listeners) listener(nextState)
  }

  public subscribe(listener: (state: GameState) => void): () => void {
    this.listeners.add(listener)
    return () => this.listeners.delete(listener)
  }
}
